import { render, staticRenderFns } from "./RecruitSection.vue?vue&type=template&id=280461ac&"
import script from "./RecruitSection.vue?vue&type=script&lang=js&"
export * from "./RecruitSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports